import { render } from "./BillingView.vue?vue&type=template&id=b8fe550a&scoped=true"
import script from "./BillingView.vue?vue&type=script&lang=js"
export * from "./BillingView.vue?vue&type=script&lang=js"

import "./BillingView.vue?vue&type=style&index=0&id=b8fe550a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8fe550a"]])

export default __exports__